var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF7661"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5068 8H11.5023C9.01701 8 7 10.008 7 12.4842V17.8689V18.7694C7 21.2456 9.01701 23.2536 11.5023 23.2536H12.8529C13.096 23.2536 13.4202 23.4157 13.5733 23.6138L14.924 25.4057C15.5183 26.1981 16.4907 26.1981 17.085 25.4057L18.4357 23.6138C18.6068 23.3887 18.8769 23.2536 19.1561 23.2536H20.5068C22.992 23.2536 25.009 21.2456 25.009 18.7694V12.4842C25.009 10.008 22.992 8 20.5068 8ZM12.4027 17.0045C11.8984 17.0045 11.5023 16.5993 11.5023 16.1041C11.5023 15.6088 11.9075 15.2036 12.4027 15.2036C12.8979 15.2036 13.3032 15.6088 13.3032 16.1041C13.3032 16.5993 12.907 17.0045 12.4027 17.0045ZM16.0045 17.0045C15.5002 17.0045 15.1041 16.5993 15.1041 16.1041C15.1041 15.6088 15.5093 15.2036 16.0045 15.2036C16.4997 15.2036 16.905 15.6088 16.905 16.1041C16.905 16.5993 16.5088 17.0045 16.0045 17.0045ZM19.6063 17.0045C19.102 17.0045 18.7059 16.5993 18.7059 16.1041C18.7059 15.6088 19.1111 15.2036 19.6063 15.2036C20.1015 15.2036 20.5068 15.6088 20.5068 16.1041C20.5068 16.5993 20.1106 17.0045 19.6063 17.0045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebchat);
export default __webpack_public_path__ + "static/media/Webchat.69e107ff.svg";
export { ForwardRef as ReactComponent };